import React from "react";

function Description() {
  return (
    <>
    <div className="mx-auto justify-between pt-28 md:pt-52 max-w-screen-xl md:px-10 px-5 pb-32">
      <div className="">
        <div className="second">
          <span className="text-[#00713B] border-b border-[#00713B]">
            Our Privacy Policy
          </span>
        </div>

        <div className="max-w-screen-lg pt-5 md:pt-8 text-[#777] third">
          <p className="md:text-lg text-sm">
            This Privacy Policy applies between you, the User of this Website, and Hilal ESG Holdings LTD, the owner and
            provider of this Website. Hilal ESG Holdings LTD takes the privacy of your information very seriously. This Privacy
            Policy applies to our use of any and all Data collected by us or provided by you in relation to your use of the Website.
          </p>
        </div>
      </div>
        <h1 className="text-base font-semibold text-[#444444] py-3 mt-5">
            Please read this Privacy Policy carefully.
        </h1>
        <h2 className="text-base font-semibold text-[#444444]">Definitions and Interpretation</h2>
        <p className="md:text-lg text-sm mt-2 font-light">
            In this Privacy Policy, the following definitions are used:
        </p>
        <div className="mx-auto pt-5 md:pt-8 text-[#777]">
            <table className="w-full mt-4 border border-black text-sm md:text-base">
                <tbody>
                <tr className="border border-black">
                    <td className="p-2 border border-black text-[#444]">Data</td>
                    <td className="p-2 border border-black md:text-base text-sm text-[#777]">
                        collectively all information that you submit to Hilal ESG Holdings LTD via the Website. This definition incorporates, where applicable, the definitions provided in the Data Protection Laws;
                    </td>
                </tr>
                <tr className="border border-black">
                    <td className="p-2 border border-black text-[#444]">Cookies</td>
                    <td className="p-2 border border-black md:text-base text-sm text-[#777]">
                    a small text file placed on your computer by this Website when you visit certain parts of the Website and/or when you use certain features of the Website. Details of the cookies used by this Website are set out in the clause below (Cookies);
                    </td>
                </tr>
                <tr className="border border-black">
                    <td className="p-2 border border-black text-[#444]">Data Protection Laws</td>
                    <td className="p-2 border border-black md:text-base text-sm text-[#777]">
                    any applicable law relating to the processing of personal Data, including but not limited to the GDPR, and any national implementing and supplementary laws, regulations and secondary legislation;
                    </td>
                </tr>
                <tr className="border border-black">
                    <td className="p-2 border border-black text-[#444]">GDPR</td>
                    <td className="p-2 border border-black md:text-base text-sm text-[#777]">
                    the UK General Data Protection Regulation;
                    </td>
                </tr>
                <tr className="border border-black">
                    <td className="p-2 border border-black text-[#444]">Hilal ESG LTD, we or us</td>
                    <td className="p-2 border border-black md:text-base text-sm text-[#777]">
                    Hilal ESG Holdings LTD of 7 Bell Yard, London, England, WC2A 2JR;
                    </td>
                </tr>
                <tr className="border border-black">
                    <td className="p-2 border border-black text-[#444]">UK and EU Cookie Law</td>
                    <td className="p-2 border border-black md:text-base text-sm text-[#777]">
                    the Privacy and Electronic Communications (EC Directive) Regulations 2003 as amended by the Privacy and Electronic Communications (EC Directive) (Amendment) Regulations 2011 & the Privacy and Electronic Communications (EC Directive) (Amendment) Regulations 2018;
                    </td>
                </tr>
                <tr className="border border-black">
                    <td className="p-2 border border-black text-[#444]">User or you</td>
                    <td className="p-2 border border-black md:text-base text-sm text-[#777]">
                    any third party that accesses the Website and is not either (i) employed by Hilal ESG Holdings LTD and acting in the course of their employment or (ii) engaged as a consultant or otherwise providing services to Hilal ESG Holdings LTD and accessing the Website in connection with the provision of such services; and
                    </td>
                </tr>
                <tr className="border border-black">
                    <td className="p-2 border border-black text-[#444]">Website</td>
                    <td className="p-2 border border-black md:text-base text-sm text-[#777]">
                    the website that you are currently using, www.zexcella.co.uk, and any sub-domains of this site unless expressly excluded by their own terms and conditions.
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div className="max-w-screen-lg pt-6 md:pt-10 third">
            <p className="md:text-base text-sm text-[#777]">
                In this Privacy Policy, unless the context requires a different interpretation:
                the singular includes the plural and vice versa;
                <br />
                references to sub-clauses, clauses, schedules or appendices are to sub-clauses, clauses, schedules or appendices of this
                Privacy Policy;
                <br />
                a reference to a person includes firms, companies, government entities, trusts and partnerships;
                "including" is understood to mean "including without limitation";
                <br />
                reference to any statutory provision includes any modification or amendment of it;
                the headings and sub-headings do not form part of this Privacy Policy.
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Scope of this Privacy Policy</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                In this Privacy Policy, unless the context requires a different interpretation:
                the singular includes the plural and vice versa;
                <br />
                references to sub-clauses, clauses, schedules or appendices are to sub-clauses, clauses, schedules or appendices of this
                Privacy Policy;
                <br />
                a reference to a person includes firms, companies, government entities, trusts and partnerships;
                "including" is understood to mean "including without limitation";
                <br />
                reference to any statutory provision includes any modification or amendment of it;
                the headings and sub-headings do not form part of this Privacy Policy.
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Data Collected</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                We may collect the following Data, which includes personal Data, from you:
                name;
                <br />
                contact Information such as email addresses and telephone numbers;
                IP address (automatically collected);
                email;
                <br />
                in each case, in accordance with this Privacy Policy.
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">How We Collect Data</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                We collect Data in the following ways:
                <br />
                data is given to us by you; and
                <br />
                data is collected automatically.
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Data That is Given to Us by You</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                Hilal ESG Holdings LTD will collect your Data in a number of ways, for example:
                <br />
                when you contact us through the Website, by telephone, post, e-mail or through any other means;
                <br />
                when you use our services;
                <br />
                in each case, in accordance with this Privacy Policy.
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Data That is Collected Automatically</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                To the extent that you access the Website, we will collect your Data automatically, for example:
                <br />
                we automatically collect some information about your visit to the Website. This information helps us to make
                improvements to Website content and navigation, and includes your IP address, the date, times and frequency with
                which you access the Website and the way you use and interact with its content.
                <br />
                we will collect your Data automatically via cookies, in line with the cookie settings on your browser. For more
                information about cookies, and how we use them on the Website, see the section below, headed "Cookies".
            </p>
        </div>

        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Our Use of Data</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                Any or all of the above Data may be required by us from time to time in order to provide you with the best possible
                service and experience when using our Website. Specifically, Data may be used by us for the following reasons:
                <br />
                internal record keeping;
                <br />
                to communicate with the client;
                <br/>
                in each case, in accordance with this Privacy Policy.
                <br/>
                We may use your Data for the above purposes if we deem it necessary to do so for our legitimate interests. If you are
                not satisfied with this, you have the right to object in certain circumstances (see the section headed "Your rights"
                below).
                <br/>
                We may use your Data to show you Hilal ESG Holdings LTD adverts and other content on other websites. If you do
                not want us to use your data to show you Hilal ESG Holdings LTD adverts and other content on other websites, please
                turn off the relevant cookies (please refer to the section headed "Cookies" below).
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Who We Share Data With</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                We may share your Data with the following groups of people for the following reasons:
                <br />
                our employees, agents and/or professional advisors - to obtain advice from professional advisers;
                <br />
                in each case, in accordance with this Privacy Policy.
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Keeping Data Secure</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                We will use technical and organisational measures to safeguard your Data, for example:
                <br />
                access to your account is controlled by a password and a user name that is unique to you.
                <br />
                we store your Data on secure servers.
                <br />
                Technical and organisational measures include measures to deal with any suspected data breach. If you suspect any
                misuse or loss or unauthorised access to your Data, please let us know immediately by contacting us via this e-mail
                address: admin@hilalesg.com.
                <br />
                If you want detailed information from, Get Safe Online on how to protect your information and your computers and
                devices against fraud, identity theft, viruses and many other online problems, please visit www.getsafeonline.org. Get
                Safe Online is supported by HM Government and leading businesses.
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Data Retention</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                Unless a longer retention period is required or permitted by law, we will only hold your Data on our systems for the
                period necessary to fulfil the purposes outlined in this Privacy Policy or until you request that the Data be deleted.
                Even if we delete your Data, it may persist on backup or archival media for legal, tax or regulatory purposes.
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Your Rights</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                You have the following rights in relation to your Data:
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Right to access</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                The right to request (i) copies of the information we hold about you at any time, or (ii) that we
                modify, update or delete such information. If we provide you with access to the information we hold about you, we
                will not charge you for this, unless your request is "manifestly unfounded or excessive." Where we are legally
                permitted to do so, we may refuse your request. If we refuse your request, we will tell you the reasons why.
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Right to correct</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                The right to have your Data rectified if it is inaccurate or incomplete.
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Right to erase</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                The right to request that we delete or remove your Data from our systems.
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Right to restrict our use of your Data</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                The right to "block" us from using your Data or limit the way in which we can
                use it.
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Right to data portability</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                The right to request that we move, copy or transfer your Data.
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Right to object</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                The right to object to our use of your Data including where we use it for our legitimate interests.
                To make enquiries, exercise any of your rights set out above, or withdraw your consent to the processing of your Data
                (where consent is our legal basis for processing your Data), please contact us via this e-mail
                address: admin@hilalesg.com.
                <br />
                If you are not satisfied with the way a complaint you make in relation to your Data is handled by us, you may be able
                to refer your complaint to the relevant data protection authority. For the UK, this is the Information Commissioner's
                Office (ICO). The ICO's contact details can be found on their website at https://ico.org.uk/.
                It is important that the Data we hold about you is accurate and current. Please keep us informed if your Data changes
                during the period for which we hold it.
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Transfers Outside the United Kingdom and European Economic Area</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                Data which we collect from you may be stored and processed in and transferred to countries outside of the UK and
                European Economic Area (EEA). For example, this could occur if our servers are located in a country outside the UK
                or EEA or one of our service providers is situated in a country outside the UK or EEA.
                <br />
                We will only transfer Data outside the UK or EEA where it is compliant with data protection legislation and the means
                of transfer provides adequate safeguards in relation to your data, e.g., by way of data transfer agreement, incorporating
                the current standard contractual clauses adopted by the European Commission.
                <br />
                To ensure that your Data receives an adequate level of protection, we have put in place appropriate safeguards and
                procedures with the third parties we share your Data with. This ensures your Data is treated by those third parties in a
                way that is consistent with the Data Protection Laws.
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Links to Other Websites</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                This Website may, from time to time, provide links to other websites. We have no control over such websites and are
                not responsible for the content of these websites. This Privacy Policy does not extend to your use of such websites.
                You are advised to read the Privacy Policy or statement of other websites prior to using them.
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Changes of Business Ownership and Control</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                Hilal ESG Holdings LTD may, from time to time, expand or reduce our business and this may involve the sale and/or
                the transfer of control of all or part of Hilal ESG Holdings LTD . Data provided by Users will, where it is relevant to
                any part of our business so transferred, be transferred along with that part and the new owner or newly controlling
                party will, under the terms of this Privacy Policy, be permitted to use the Data for the purposes for which it was
                originally supplied to us.
                <br />
                We may also disclose Data to a prospective purchaser of our business or any part of it.
                In the above instances, we will take steps with the aim of ensuring your privacy is protected.
            </p>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Cookies</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                This Website may place and access certain Cookies on your computer. Hilal ESG Holdings LTD Cookies to improve
                your experience of using the Website and to improve our range of products and services. Hilal ESG Holdings LTD has
                carefully chosen these Cookies and has taken steps to ensure that your privacy is protected and respected at all times.
                All Cookies used by this Website are used in accordance with current UK and EU Cookie Law.
                <br />
                Before the Website places Cookies on your computer, you will be presented with a message bar requesting your
                consent to set those Cookies. By giving your consent to the placing of Cookies, you are enabling Hilal ESG Holdings
                LTD to provide a better experience and service to you. You may, if you wish, deny consent to the placing of Cookies;
                however certain features of the Website may not function fully or as intended.
                <br />
                This Website may place the following Cookies:
            </p>
        </div>

        <div className="mx-auto pt-5 md:pt-8 text-[#333]"> 
            <div className="mt-6">
                <section>
                    <table className="w-full mt-2 border border-gray-300 text-sm md:text-base">
                        <thead>
                            <tr className="bg-gray-100">
                                <th className="p-3 border border-gray-300 font-semibold text-start">Type of Cookie</th>
                                <th className="p-3 border border-gray-300 font-semibold text-start">Purpose</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="border border-gray-300">
                                <td className="p-3 border border-gray-300">Strictly necessary cookies</td>
                                <td className="p-3 border border-gray-300">
                                    These are cookies that are required for the operation of
                                    our website. They include, for example, cookies that
                                    enable you to log into secure areas of our website, use a
                                    shopping cart or make use of e-billing services.
                                </td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr className="border border-gray-300">
                                <td className="p-3 border border-gray-300">Analytical/performance cookies</td>
                                <td className="p-3 border border-gray-300">
                                    They allow us to recognise and count the number of
                                    visitors and to see how visitors move around our website
                                    when they are using it. This helps us to improve the way
                                    our website works, for example, by ensuring that users
                                    are finding what they are looking for easily.
                                </td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr className="border border-gray-300">
                                <td className="p-3 border border-gray-300">Functionality cookies</td>
                                <td className="p-3 border border-gray-300">
                                    These are used to recognise you when you return to our
                                    website. This enables us to personalise our content for
                                    you, greet you by name and remember your preferences
                                    (for example, your choice of language or region). By
                                    using the Website, you agree to our placement of
                                    functionality cookie.
                                </td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr className="border border-gray-300">
                                <td className="p-3 border border-gray-300">Targeting cookies</td>
                                <td className="p-3 border border-gray-300">
                                    These cookies record your visit to our website, the pages
                                    you have visited and the links you have followed. We
                                    will use this information to make our website and the
                                    advertising displayed on it more relevant to your
                                    interests. We may also share this information with third
                                    parties for this purpose.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>
            </div>
        </div>
        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <p className="md:text-base text-sm pt-5 text-[#777]">
                You can find a list of Cookies that we use in the Cookies Schedule.
                <br />
                You can choose to enable or disable Cookies in your internet browser. By default, most internet browsers accept
                Cookies but this can be changed. For further details, please see the help menu in your internet browser. You can switch
                off Cookies at any time, however, you may lose any information that enables you to access the Website more quickly
                and efficiently.
                <br />
                You can choose to delete Cookies at any time; however, you may lose any information that enables you to access the
                Website more quickly and efficiently including, but not limited to, personalisation settings.
                <br />
                It is recommended that you ensure that your internet browser is up-to-date and that you consult the help and guidance
                provided by the developer of your internet browser if you are unsure about adjusting your privacy settings.
                <br />
                For more information generally on cookies, including how to disable them, please refer to aboutcookies.org. You will
                also find details on how to delete cookies from your computer.
            </p>
        </div>

        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">General</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                You may not transfer any of your rights under this Privacy Policy to any other person. We may transfer our rights
                under this Privacy Policy where we reasonably believe your rights will not be affected.
                <br />
                If any court or competent authority finds that any provision of this Privacy Policy (or part of any provision) is invalid,
                illegal or unenforceable, that provision or part-provision will, to the extent required, be deemed to be deleted, and the
                validity and enforceability of the other provisions of this Privacy Policy will not be affected.
                <br />
                Unless otherwise agreed, no delay, act or omission by a party in exercising any right or remedy will be deemed a
                waiver of that, or any other, right or remedy.
                <br />
                This Agreement will be governed by and interpreted according to the law of England and Wales. All disputes arising
                under the Agreement will be subject to the exclusive jurisdiction of the English and Welsh courts.
            </p>
        </div>

        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Changes to This Privacy Policy</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                Hilal ESG Holdings LTD reserves the right to change this Privacy Policy as we may deem necessary from time to time
                or as may be required by law. Any changes will be immediately posted on the Website and you are deemed to have
                accepted the terms of the Privacy Policy on your first use of the Website following the alterations.
                <br />
                You may contact Hilal ESG Holdings LTD by email at admin@hilalesg.com.
            </p>
        </div>

        <div className="max-w-screen-lg pt-5 md:pt-8 third">
            <h2 className="text-base font-semibold text-[#444444]">Attribution</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                This Privacy Policy was created using a document from Rocket Lawyer (https://www.rocketlawyer.com/gb/en).
                <br />
                You may contact Hilal ESG Holdings LTD by email at admin@hilalesg.com.
            </p>
        </div>

        <div className="mx-auto pt-5 md:pt-8 text-[#333]">
            <p className="md:text-base text-sm pt-5 text-[#777]">
                This Privacy Policy was created on 08 February 2024.
            </p>
            <h2 className="text-lg font-semibold text-[#444444] pt-5">Cookie Details</h2>
            <p className="md:text-base text-sm pt-5 text-[#777]">
                Below is a list of the cookies that we use. We have tried to ensure this is complete and up to date, but if you think that
                we have missed a cookie or there is any discrepancy, please let us know.
            </p>
            
            <div className="mt-6">
                <section>
                <h3 className="font-semibold">Strictly Necessary</h3>
                <p>We use the following strictly necessary cookies:</p>
                <table className="w-full mt-2 border border-gray-300 text-sm md:text-base">
                    <thead>
                    <tr className="bg-gray-100">
                        <th className="p-3 border border-gray-300 font-semibold">Description</th>
                        <th className="p-3 border border-gray-300 font-semibold">Purpose</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr className="border border-gray-300">
                        <td className="p-3 border border-gray-300">We use this session cookie to remember you and maintain your session whilst you are using our website</td>
                        <td className="p-3 border border-gray-300 text-center">---------</td>
                    </tr>
                    </tbody>
                </table>
                </section>

                <section className="mt-6">
                <h3 className="font-semibold">Functionality</h3>
                <p>We use the following functionality cookies:</p>
                <table className="w-full mt-2 border border-gray-300 text-sm md:text-base">
                    <thead>
                    <tr className="bg-gray-100">
                        <th className="p-3 border border-gray-300 font-semibold">Description</th>
                        <th className="p-3 border border-gray-300 font-semibold">Purpose</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr className="border border-gray-300">
                        <td className="p-3 border border-gray-300">We use this cookie to identify your computer and analyze traffic patterns on our website</td>
                        <td className="p-3 border border-gray-300 text-center">---------</td>
                    </tr>
                    </tbody>
                </table>
                </section>

                <section className="mt-6">
                <h3 className="font-semibold">Analytical/Performance</h3>
                <p>We use the following analytical/performance cookies:</p>
                <table className="w-full mt-2 border border-gray-300 text-sm md:text-base">
                    <thead>
                    <tr className="bg-gray-100">
                        <th className="p-3 border border-gray-300 font-semibold">Description</th>
                        <th className="p-3 border border-gray-300 font-semibold">Purpose</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr className="border border-gray-300">
                        <td className="p-3 border border-gray-300">We use this cookie to help us analyse how users use the website</td>
                        <td className="p-3 border border-gray-300 text-center">---------</td>
                    </tr>
                    </tbody>
                </table>
                </section>

                <section className="mt-6">
                <h3 className="font-semibold">Targeting</h3>
                <p>We use the following targeting cookies:</p>
                <table className="w-full mt-2 border border-gray-300 text-sm md:text-base">
                    <thead>
                    <tr className="bg-gray-100">
                        <th className="p-3 border border-gray-300 font-semibold">Description</th>
                        <th className="p-3 border border-gray-300 font-semibold">Purpose</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr className="border border-gray-300">
                        <td className="p-3 border border-gray-300">We use this cookie to enable us to show you adverts while you are browsing our website and other websites on the internet</td>
                        <td className="p-3 border border-gray-300 text-center">---------</td>
                    </tr>
                    </tbody>
                </table>
                </section>
            </div>
        </div>
    </div>
    </>
  );
}

export default Description;